import React from 'react';
import { connect } from 'react-redux';
import SignupForm from '../SignupForm';
import {
  submitCreateAccountForImportForm,
  showRequestResetPassword,
} from '../../user';
import { ONBOARDING_VANITY_URL_FORM } from '../../onboarding';

const CREATE_ACCOUNT_FORM = 'createAccount';

const mapDispatchToProps = (dispatch, { submitCallback }) => ({
  onSubmit: data =>
    dispatch(submitCreateAccountForImportForm(data, submitCallback)),
  loginUrl: '/switch/login',
  onClickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const mapStateToProps = ({ routing, form, onboarding: { rssFeed } }) => ({
  routing,
  feedUrl: rssFeed,
  enableReinitialize: true,
  initialValues: getInitialValuesFromForm(form),
  isImporting: true,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupForm);

function getVanitySlugFromForm(form) {
  const onboardingForm = form[ONBOARDING_VANITY_URL_FORM];
  if (onboardingForm.values && onboardingForm.values.vanitySlug) {
    return onboardingForm.values.vanitySlug;
  }
  return null;
}

// Restores any current values in the form (otherwise they get cleared), but also populates vanity slug if it has changed from a related form (e.g. onboarding)
function getInitialValuesFromForm(form) {
  const createAccountForm = form[CREATE_ACCOUNT_FORM];
  if (!createAccountForm || !createAccountForm.values) {
    return {};
  }
  return {
    ...createAccountForm.values,
    vanitySlug: getVanitySlugFromForm(form),
  };
}
